import { cx } from "shared/utils";
import { IntegrationId } from "views/settings-integration/components/AddIntegrationModal/types";
import { INTEGRATION_LOGO } from "views/settings-integration/constants";

interface IntegrationLogoIconProps {
  id: IntegrationId;
  size?: "SM" | "BASE";
}

export const IntegrationLogoIcon = ({
  id,
  size = "BASE"
}: IntegrationLogoIconProps) => {
  const logo = INTEGRATION_LOGO[id];
  if (!logo) return null;

  return (
    <div
      className={cx(
        "rounded-lg flex items-center justify-center shrink-0",
        size === "BASE" ? "size-10" : "size-8"
      )}
      style={{ backgroundColor: logo.bg }}
    >
      <img
        src={logo.src}
        alt={id}
        className={cx(logo.imgClassName, "object-contain")}
      />
    </div>
  );
};
